var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-switch",class:{ disable: _vm.disable }},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"input":function($event){return _vm.$emit('input', !_vm.value)}}}),_vm._v(" "),_c('i')])}
var staticRenderFns = []

export { render, staticRenderFns }